import { render, staticRenderFns } from "./admincoinloglist.vue?vue&type=template&id=c0c96424&scoped=true"
import script from "./admincoinloglist.vue?vue&type=script&lang=js"
export * from "./admincoinloglist.vue?vue&type=script&lang=js"
import style0 from "./admincoinloglist.vue?vue&type=style&index=0&id=c0c96424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c96424",
  null
  
)

export default component.exports